import type { IOrganizationFeaturePartnerPortalPermissions } from './OrganizationFeaturePartnerPortalPermissions.interface';

export default class OrganizationFeaturePartnerPortalPermissions
  implements IOrganizationFeaturePartnerPortalPermissions {
  editFactFind: boolean;
  defaultWorkflow: string;

  static build = (data: IOrganizationFeaturePartnerPortalPermissions) =>
    new OrganizationFeaturePartnerPortalPermissions(data);

  static blank = () => new OrganizationFeaturePartnerPortalPermissions();

  /**
   * Constructor
   * @param {IOrganizationFeaturePartnerPortalPermissions} data
   */
  constructor(data?: IOrganizationFeaturePartnerPortalPermissions) {
    this.editFactFind = data?.editFactFind === true;
    this.defaultWorkflow = data?.defaultWorkflow || undefined;
  }
}
